// Necessary for module federation
import("./bootstrap");
export {};
